var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlyJsonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 181,
    viewBox: "0 0 237 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.846 0.282843C127.046 1.08284 126.146 2.78284 121.646 15.5828C119.246 22.2828 117.346 27.9828 117.346 28.1828C117.346 28.3828 144.046 28.5828 176.646 28.5828H235.946L234.546 23.2828C233.746 20.3828 232.046 14.3828 230.646 10.0828C228.646 3.38284 228.046 1.98284 226.946 1.18284C225.646 0.182841 225.546 0.182843 178.446 0.0828426C151.446 -0.117157 130.646 0.0828433 129.846 0.282843Z",
    fill: "#006AB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0458648 36.983C0.345865 37.583 0.545865 60.883 0.545865 109.083V180.283H94.4459C146.046 180.283 199.046 180.383 212.146 180.583L236.046 180.883V108.383V36.083H117.846C1.04587 36.083 -0.454135 36.083 0.0458648 36.983ZM131.046 85.283V103.883H139.546C144.246 103.883 147.946 104.083 147.846 104.283C147.546 104.983 114.246 143.383 113.946 143.383C113.746 143.383 105.946 134.583 96.5459 123.783L79.4459 104.183L88.0459 104.083L96.6459 103.983V85.383V66.783H113.846H131.046V85.283Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyJsonIcon);
export default __webpack_public_path__ + "static/media/onlyJsonIcon.ef155b715d4d834f28afa4f2723d136a.svg";
export { ForwardRef as ReactComponent };